export default __webpack_public_path__ + "static/media/itemCombo2.13641e52.png";